<template>
    <div>
        <div class="title">
            <span style="cursor: pointer" @click="$router.go(-1)">数据分析</span>
            > <span>发货统计</span>
        </div>
        <div>
            <div class="main">
                <!-- 搜索框渲染 -->
                <div class="demo-form-title">
                    <img :src="ImgIcon" alt="" style="margin-right: 6px" />
                    <div class="demo-form-fist">发货统计</div>
                    <div class="demo-form-fu">物流公司物流费用统计</div>
                </div>
                <div style="margin-left: 50px">
                    <Todayapick :SubmitBleen="SubmitBleen" @GetArrayList="GetArrayList"></Todayapick>
                </div>
            </div>
            <div class="concet">
                <!-- 饼状图渲染 -->
                <div style="flex: 1; background: #fff">
                    <div class="statistics_title">物流公司物流费用统计</div>
                    <div id="EChart" style="width: 100%; height: 500px"></div>
                </div>
                <div style="flex: 2; margin-left: 20px; background: #fff">
                    <div class="ExportBox ExportBoxBBm">
                        <span class="ExportBtn" @click="GetListExportBtn">导出表格</span>
                    </div>
                    <!-- 数据表格渲染 -->
                    <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F5F6FA' }">
                        <el-table-column header-align="center" align="center" prop="orderNo" label="订单编号" width="180"> </el-table-column>
                        <el-table-column header-align="center" align="center" prop="mobile" label="下单手机" width="280"> </el-table-column>
                        <el-table-column header-align="center" align="center" prop="price" label="物流单价（元）" width="100"> 
                            <template  slot-scope="scope">
                                <span>{{scope.row.price | rounding}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="name" label="物流公司" width="200"> </el-table-column>
                        <el-table-column header-align="center" align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 点击查看弹出框 -->
                    <el-dialog title="订单详情" :visible.sync="centerDialogVisible" top="12vh" v-if="OrderInformation" width="60%" class="Dialog_title">
                        <div class="Dialog_box">
                            <div style="flex: 1">
                                <div class="Dialog_sm_title"><span class="Dialog_sm_title_concet">订单信息 </span></div>
                                <div class="Dialog_concet">
                                    <div class="lh32">
                                        <span class="mr40">订单编号</span>
                                        <span>{{ OrderInformation.orderNo }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">用户手机</span>
                                        <span>{{ OrderInformation.mobile }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">商品名称</span>
                                        <span>{{ OrderInformation.goodsName }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">数量</span>
                                        <span>{{ OrderInformation.goodsNum }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">销售价</span>
                                        <span>{{ OrderInformation.goodsNum }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">总价</span>
                                        <span>{{ OrderInformation.totalPrice }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">优惠券</span>
                                        <span>{{ OrderInformation.totalPrice }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">快递费</span>
                                        <span>{{ OrderInformation.logisticsPrice }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">支付金额</span>
                                        <span>{{ OrderInformation.payPrice }}</span>
                                    </div>
                                    <div class="lh32">
                                        <span class="mr40">订单状态</span>
                                        <span>{{ OrderInformation.orderState }}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1">
                                <div>
                                    <div class="Dialog_sm_title"><span class="Dialog_sm_title_concet">支付信息</span></div>
                                    <div class="Dialog_concet">
                                        <div class="lh32">
                                            <span class="mr40">支付状态</span>
                                            <span>{{ payInfomation.payState }}</span>
                                        </div>
                                        <div class="lh32">
                                            <span class="mr40">支付方式</span>
                                            <span>{{ payInfomation.payWay }}</span>
                                        </div>
                                        <div class="lh32">
                                            <span class="mr40">支付时间</span>
                                            <span>{{ payInfomation.payTime }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="Dialog_sm_title Dialog_wl_title"><span class="Dialog_sm_title_concet">物流信息</span></div>
                                    <div class="Dialog_concet">
                                        <div class="lh32">
                                            <span class="mr40">发货时间</span>
                                            <span>{{ logisticsInformation.sendTime }}</span>
                                        </div>
                                        <div class="lh32">
                                            <span class="mr40">收货人</span>
                                            <span>{{ logisticsInformation.receiver }}</span>
                                        </div>
                                        <div class="lh32">
                                            <span class="mr40">联系电话</span>
                                            <span>{{ logisticsInformation.mobile }}</span>
                                        </div>
                                        <div class="lh32">
                                            <span class="mr40">收货地址</span>
                                            <span>{{ logisticsInformation.receiverAddress }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>
                    <!-- 表格末尾的分页 -->
                    <div class="ExportBoxBm">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            layout="prev, pager, next, sizes, jumper"
                            :total="total"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Todayapick from "@/components/AnalysisPicker/TimePicker.vue";
let echarts = require("echarts");
export default {
    components: { Todayapick },
    data() {
        return {
            ImgIcon: require("@/assets/icon/icon_fenle.png"), //顶部图标
            SubmitBleen: false, //子组件是否展示搜索
            pickerOptions: {
                //限制选择当前时间之后的方法
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
                },
            },
            ruleForm: {
                //搜索框所需绑定的值
                prolei: "", //商品的名称
                time: "",
                StartTime: "",
                EndTime: "",
            },
            tableData: [], //表格的数据
            pageSize: 10, //分页每页的条数
            currentPage: 0, //分页的页数
            centerDialogVisible: false, //是否展示弹出框
            ExpressDelivery: [], //柱状图的数组
            total: 0, //表格总条数
            OrderInformation: {}, //订单信息查看详情订单信息
            payInfomation: {}, //订单信息查看详情订单信息
            logisticsInformation: {}, //订单信息查看详情订单信息
            shopIDList: [], //商户ID的数组
        };
    },
    created() {},
    filters: {
        rounding (value) {
            return value.toFixed(2)
        }
    },
    mounted() {
        let shopIDList = JSON.parse(localStorage.getItem("shop")).shop;
        shopIDList.forEach((item) => {
            this.shopIDList.push(item.shop_id);
        });
        this.DefaultTime();
        this.GetCompaniesRatioArray(this.ruleForm.StartTime, this.ruleForm.EndTime); //vuex中请求的接口物流公司发货占比
        this.GetShippingStatistics(this.ruleForm.StartTime, this.ruleForm.EndTime);
    },
    computed: {},
    methods: {
        ...mapActions({
            CompaniesRatio: "dataAnalysis/CompaniesRatio", //vuex中请求的接口物流公司发货占比
            ShippingStatistics: "dataAnalysis/ShippingStatistics", //发货统计的接口
            InquiryDetails: "dataAnalysis/InquiryDetails", //查询详情接口
            ShippingStatisticsExport: "dataAnalysis/ShippingStatisticsExport", //导出接口
        }),
        InquiryDetailsItem(item) {
            this.InquiryDetails({ orderNo: item }).then((res) => {
                if (res.code === 10000) {
                    this.OrderInformation = res.data.orderInfo;
                    this.payInfomation = res.data.payInfo;
                    this.logisticsInformation = res.data.logisticsInfo;
                    this.total = res.total;
                }
            });
        },
        GetShippingStatistics(state, end) {
            //执行发货统计的接口
            let params = {
                shopIdList: this.shopIDList,
                pageSize: this.pageSize,
                pageIndex: this.currentPage,
                timeBegin: state,
                timeEnd: end,
            };
            this.ShippingStatistics(params).then((res) => {
                if ((res.code === 10000)) {
                    this.tableData = res.data;
                }
            });
        },
        DefaultTime() {
            //默认查询当前时间
            var endData = new Date();
            var month = parseInt(endData.getMonth() + 1);
            var day = endData.getDate();
            var hous = endData.getHours();
            var minu = endData.getSeconds();
            var fend = endData.getMinutes();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            if (hous < 10) {
                hous = "0" + hous;
            }
            if (fend < 10) {
                fend = "0" + fend;
            }
            this.ruleForm.StartTime = endData.getFullYear() + "-" + month + "-" + day + " " + "00:00:00";
            this.ruleForm.EndTime = endData.getFullYear() + "-" + month + "-" + day + " " + hous + ":" + fend + ":" + minu;
        },
        async GetCompaniesRatioArray(state, end) {
            //vuex中请求的接口物流公司发货占比
            let params = {
                shopIdList: this.shopIDList,
                timeBegin: state,
                timeEnd: end,
            };
            await this.CompaniesRatio(params).then((res) => {
                if (res.code === 10000 &&  res.data!=null) {
                   this.ExpressDelivery = res.data;
                }
            });
            this.getRenderer(); //商品销售饼状图渲染执行

        },
        getRenderer() {
            //商品销售饼状图渲染事件
            let dataName = []
            let datanum = []
            if (this.ExpressDelivery.length > 0) {
                for (var i = 0; i < this.ExpressDelivery.length; i++) {
                    dataName.push(this.ExpressDelivery[i].name);
                    datanum.push(this.ExpressDelivery[i].price);
                }
            }
            let EChart = echarts.init(document.getElementById("EChart"));
            let config = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                dataZoom: [
                    {
                        type: "slider",
                        show: true,
                        yAxisIndex: [10],
                        left: "93%",
                        start: 100,
                        end: 0,
                    },
                ],
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "value",
                    boundaryGap: [0, 0.001],
                },
                yAxis: {
                    type: "category",
                    data: dataName,
                },
                series: [
                    {
                        name: "2011",
                        type: "bar",
                        data: datanum,
                        // barMaxWidth:30,
                        barWidth: 30,
                        barMinHeight:10,
                        itemStyle: {
                            normal: {
                                //柱状图颜色
                                // color:'#ff6600',
                                label: {
                                    show: true, //显示文本
                                    position: "right", //数据值位置
                                    textStyle: { color: "#000" },
                                    formatter: function (params) {
                                        // 假设此轴的 type 为 'time'。
                                        return  params.value+"元";
                                    },
                                },
                            },
                        },
                    },
                ],
            };
            // 设置参数
            EChart.setOption(config);
        },
        GetArrayList(event) {
            //搜索框子组件触发的方法 获取所需值
            this.GetCompaniesRatioArray(event.StartTime, event.EndTime); //vuex中请求的接口物流公司发货占比
            this.GetShippingStatistics(event.StartTime, event.EndTime);
        },
        handleClick(item) {
            //表格查看操作
            this.centerDialogVisible = true;
            let arr = item.orderNo;
            this.InquiryDetailsItem(arr);
        },
        handleSizeChange(val) {
            //修改条数的事件
            this.pageSize = val;
            this.GetShippingStatistics(this.ruleForm.StartTime, this.ruleForm.EndTime);
        },
        handleCurrentChange(val) {
            //修改页数的事件
            this.currentPage = val;
            this.GetShippingStatistics(this.ruleForm.StartTime, this.ruleForm.EndTime);
        },
        GetListExportBtn() {
            //触发导出按钮的事件
            let params = {
                shopIdList: this.shopIDList,
                pageSize: this.pageSize,
                pageIndex: this.currentPage,
                timeBegin: this.ruleForm.StartTime,
                timeEnd: this.ruleForm.EndTime,
            };
            this.ShippingStatisticsExport(params).then((res) => {
                if (res.code === 10000) {
                    this.getExcel(this.tableData); //前端实现导出execl触发方法
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getExcel(arr) {
            //进行execl的表头
            require.ensure([], () => {
                // 这里 require 的地址指向你项目中 Export2Excel.js 文件存放地址
                const { export_json_to_excel } = require("../../../excel/Export2Excel.js");
                const tHeader = ["订单编号", "下单手机", "物流单价（元）", "物流公司"];
                const filterVal = ["orderNo", "mobile", "price", "name"];
                const data = this.formatJson(filterVal, arr);
                export_json_to_excel(tHeader, data, "发货统计");
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
    },
};
</script>
<style lang="scss" scoped>
ul,
li {
    padding: 0;
    margin: 0;
    list-style: none;
}
.main {
    min-width: 1200px;
    margin: 16px 24px;
    background: #fff;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 18px;
    color: #333;
    width: 100%;
    padding: 15px 32px;
}
.demo-form-title {
    display: flex;
    .demo-form-fist {
        font-size: 16px;
        color: #333;
    }
    .demo-form-fu {
        margin-left: 19px;
        font-size: 14px;
        color: #999;
    }
}
.concet {
    // border: 1px solid #ccc;
    min-width: 1200px;
    height: 100%;
    padding: 0 24px;
    display: flex;
    justify-content: flex-start;
    .statistics_title {
        margin: 30px 0 0 40px;
        color: #333333;
        line-height: 56px;
    }
}
.ExportBoxBm {
    margin-top: 50px;
    display: flex;
    justify-content: center;
}
.ExportBox {
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    padding: 20px 50px;
    border-bottom: 4px solid #f0f0f0;
    .ExportBtn {
        width: 80px;
        height: 40px;
        background-color: #409eff;
        text-align: center;
        border-radius: 5px;
        line-height: 40px;
        color: #fff;
        cursor: pointer;
    }
}
.CommodityBox {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    .Commodity {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
    .CommodityRbox {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .CommodityName {
            margin-left: 5px;
            color: #999;
        }
        .CommodityVal {
            color: #409eff;
        }
    }
}
.Dialog_box {
    display: flex;
    background-color: #f7f7f7;
    margin: 0 60px;
    padding: 40px 45px 45px 30px;
    border-radius: 4px;
    .Dialog_sm_title {
        font-size: 16px;
        font-weight: 600;
        border-left: 3px solid #409eff;
        margin-bottom: 6px;
        .Dialog_sm_title_concet {
            margin-left: 20px;
        }
    }
    .Dialog_wl_title {
        margin-top: 18px;
    }
    .Dialog_concet {
        margin-left: 40px;
        font-size: 14px;
        .lh32 {
            padding: 15px 0;
            .mr40 {
                width: 60px;
                display: inline-block;
                text-align: right;
                margin-right: 40px;
            }
        }
    }
}
.dialog-footer {
    display: flex;
    justify-content: center;
}
</style>